import { eAdMode, eAdState, eAdShowRes, eSDKType, SDKBase } from "./SDKBase";



export class OK extends SDKBase {
    private static readonly METHOD_LOAD_AD = "prepareMidroll";
    private static readonly METHOD_SHOW_AD = "showMidroll";

    private static _self: OK;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private static API_callback(method: string, result: string, data: any): void {
        console.log("API_callback | method: " + method + " | result: " + result + " | data: " + data);

        if (method == OK.METHOD_LOAD_AD) {
            OK._self._adState[eAdMode.videoReward] = result == "ok" ? eAdState.ready : eAdState.none;
        }
        else if (method == OK.METHOD_SHOW_AD) {
            OK._self._adState[eAdMode.videoReward] = eAdState.none;
            OK._self._eventHandler.fire(OK.EVENT_AD_COMPLETE, result == "ok" ? eAdShowRes.success : eAdShowRes.failed, OK._self._adCallbackPar);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(app: pc.Application) {
        super(app, eSDKType.OK);

        OK._self = this;
        this._api = (<any>window).FAPI;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(): void {
        // Inicializace SDK
        if (this._api) {
            // Nastavit callback
            (<any>window).API_callback = OK.API_callback;

            let reqPars = this._api.Util.getRequestParameters();

            this._api.init(reqPars["api_server"], reqPars["apiconnection"],
                function () {
                    OK._self._initialized = true;
                    OK._self._eventHandler.fire(OK.EVENT_INITIALIZED, true);
                },
                function (error: string) {
                    console.log("FAPI.init() error: " + error);
                    OK._self._eventHandler.fire(OK.EVENT_INITIALIZED, false);
                }
            );
        }
        else {
            console.log("FAPI doesn't exist");
            this._eventHandler.fire(OK.EVENT_INITIALIZED, false);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    loadAd(adMode: eAdMode): boolean {
        if (super.loadAd(adMode)) {
            if (adMode == eAdMode.videoReward) {
                this._api.invokeUIMethod(OK.METHOD_LOAD_AD);
                return true;
            }

            this._adState[adMode] = eAdState.none;
        }

        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showAd(adMode: eAdMode, callbackPar: any): boolean {
        if (super.showAd(adMode, callbackPar)) {
            this._api.invokeUIMethod(OK.METHOD_SHOW_AD);
            return true;
        }

        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showInvite(par: any): void {
        if (this._initialized)
            this._api.UI.showInvite(par as string);
    }
}